<script>
	import login from '@_system/views/main/login/index.vue'
	export default {
		extends:login,
		data() {
			return {

			}
		},
		mounted() {


		},
		methods: {

		}
	}
</script>